module.exports = __webpack_public_path__ + "static/media/benedict-5.414e5670.jpg";